import { ChangeDetectionStrategy, Component, HostBinding, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotifyService, UiToast } from '../core/notify.service';
import { UiIconButtonComponent } from '../icon-button/ui-icon-button.component';

/**
 * The single toast host. Rendered once, in `app.component.html`.
 *
 * Replaces `ngx-toastr` (its own `<div class="overlay-container">` under
 * `<body>`, which `styles.scss` had to lift with `z-index: 2147483000`) and
 * three `MatSnackBar` calls that used a different position and a different
 * dismiss affordance.
 *
 * `aria-live="polite"` on the region, so a vendor using a screen reader hears
 * "Booking accepted" without the focus moving; `role="status"` rather than
 * `alert`, because an error here is additive feedback, not an interruption.
 */
@Component({
  selector: 'ui-toast-host',
  standalone: true,
  imports: [CommonModule, UiIconButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ui-toast.component.html',
})
export class UiToastHostComponent {
  readonly notify = inject(NotifyService);

  @HostBinding('class.ui-toasts') readonly base = true;
  @HostBinding('attr.aria-live') readonly live = 'polite';
  @HostBinding('attr.role') readonly role = 'status';

  trackById = (_: number, toast: UiToast) => toast.id;
}
